module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/main_sp_e2740823396972f77296bf79ba0b0949.jpg";